import { isValidElementType } from 'react-is';
import ReactLoadable from 'react-loadable';
import ActivityLoader from '../components/ActivityLoader';
import LoadableFallback from '../components/LoadableFallback';

export default function Loadable(options) {
  const loader = options.loader;
  const loading =
    !options.loading || options.loading === ActivityLoader
      ? LoadableFallback
      : options.loading;

  return ReactLoadable({
    ...options,
    loading,
    loader: () =>
      loader().then((module) => {
        const resolved =
          module && module.default !== undefined ? module.default : module;
        // connect()/memo/forwardRef components are objects, not functions
        if (!isValidElementType(resolved)) {
          throw new Error(
            'Loadable module did not provide a React component default export'
          );
        }
        return resolved;
      }),
  });
}
